import { FancyInput } from 'components/ui/Inputs';
import React from 'react';
import { setOrderNumber } from 'redux/services/twittlebugs/sparingParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';

export const OrderNumberFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setOrderNumber(value || undefined));
  }, 500);

  return <FancyInput placeholder="MDSi Sales Order Number" onChange={handleChange} allowClear />;
};
